// tslint:disable
﻿/**
 * The version of the OpenAPI document: v8
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Type of the service whose data is protected by the Microsoft 365 Backup Storage policy.
 * @export
 * @enum {string}
 */
export enum RESTM365BackupStoragePolicyServiceType {
    Exchange = 'Exchange',
    SharePoint = 'SharePoint',
    OneDrive = 'OneDrive'
}

